// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"3277eeae","141":"7d418d04","193":"f7df2979","246":"48e09c3a","275":"937a0f42","361":"ea66eaa0","368":"12d2130c","395":"737d8cd4","636":"6091fdd1","863":"6f46f93e","896":"24aec4fb","976":"53e0a4fe","986":"083ede5d","988":"fe53c7d5"}[chunkId] + ".chunk.js";
};